import React, { useState, useEffect } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { format } from "date-fns";
import logo from "../../images/hoop.png";
import { RiResetLeftLine } from "react-icons/ri";
import { IoMdClose } from "react-icons/io";
import { FaEdit, FaSave } from "react-icons/fa";
import Dialog from "../../components/Dialog/Dialog";

const Fees = () => {
  const mobileRestrictStyles = `
.mobile-restriction-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  padding: 20px;
  box-sizing: border-box;
}

.mobile-restriction-content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.mobile-restriction-icon {
  font-size: 48px;
  color: #4a6da7;
  margin-bottom: 20px;
}

.mobile-restriction-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}

.mobile-restriction-message {
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 20px;
}

@media (min-width: 1024px) {
  .mobile-restriction-overlay {
    display: none !important;
  }
}
`;
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);
  // Mock data for demo purposes
  const mockClasses = [
    { id: 1, class_name: "Nursery" },
    { id: 2, class_name: "LKG" },
    { id: 3, class_name: "UKG" },
  ];

  const mockStudents = {
    Nursery: [
      {
        id: 1,
        studentId: "RM001",
        firstName: "John",
        middleName: "",
        lastName: "Doe",
      },
      {
        id: 2,
        studentId: "RM002",
        firstName: "Jane",
        middleName: "",
        lastName: "Smith",
      },
    ],
    LKG: [
      {
        id: 3,
        studentId: "RM003",
        firstName: "Mike",
        middleName: "",
        lastName: "Johnson",
      },
      {
        id: 4,
        studentId: "RM004",
        firstName: "Sarah",
        middleName: "",
        lastName: "Williams",
      },
    ],
    UKG: [
      {
        id: 5,
        studentId: "RM005",
        firstName: "David",
        middleName: "",
        lastName: "Brown",
      },
      {
        id: 6,
        studentId: "RM006",
        firstName: "Emily",
        middleName: "",
        lastName: "Davis",
      },
    ],
  };

  const mockClassFeeConstants = [
    {
      class_name: "Nursery",
      monthly_fee: 3000,
      tiffin: 500,
      vehicle_charge: 1000,
    },
    { class_name: "LKG", monthly_fee: 3500, tiffin: 500, vehicle_charge: 1000 },
    { class_name: "UKG", monthly_fee: 4000, tiffin: 500, vehicle_charge: 1000 },
  ];

  const mockTiffinVehicleUsage = {
    RM001: { uses_tiffin: true, uses_vehicle: true },
    RM002: { uses_tiffin: false, uses_vehicle: true },
    RM003: { uses_tiffin: true, uses_vehicle: false },
    RM004: { uses_tiffin: false, uses_vehicle: false },
    RM005: { uses_tiffin: true, uses_vehicle: true },
    RM006: { uses_tiffin: false, uses_vehicle: true },
  };

  const mockStudentDues = {
    RM001: 500,
    RM002: 0,
    RM003: 1000,
    RM004: 0,
    RM005: 750,
    RM006: 0,
  };

  const [classes] = useState(mockClasses);
  const [selectedClass, setSelectedClass] = useState(null);
  const [students, setStudents] = useState([]);
  const [studentFees, setStudentFees] = useState({});
  const [pdfBlob, setPdfBlob] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [studentDues] = useState(mockStudentDues);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [receiptCounter, setReceiptCounter] = useState(1001);
  const [isGenerating, setIsGenerating] = useState(false);
  const [showFeeConstants, setShowFeeConstants] = useState(false);
  const [classFeeConstants, setClassFeeConstants] = useState(
    mockClassFeeConstants
  );
  const [editingFeeConstants, setEditingFeeConstants] = useState({});
  const [tiffinVehicleUsage] = useState(mockTiffinVehicleUsage);
  const [isEditingConstants, setIsEditingConstants] = useState(false);
  const [dialog, setDialog] = useState({
    isOpen: false,
    type: "",
    title: "",
    message: "",
  });

  const nepaliMonths = [
    { nepali: "बैशाख", english: "Baisakh" },
    { nepali: "जेठ", english: "Jestha" },
    { nepali: "असार", english: "Ashar" },
    { nepali: "श्रावण", english: "Shrawan" },
    { nepali: "भदौ", english: "Bhadra" },
    { nepali: "असोज", english: "Ashoj" },
    { nepali: "कार्तिक", english: "Kartik" },
    { nepali: "मंसिर", english: "Mangsir" },
    { nepali: "पुष", english: "Poush" },
    { nepali: "माघ", english: "Magh" },
    { nepali: "फाल्गुन", english: "Falgun" },
    { nepali: "चैत्र", english: "Chaitra" },
  ];

  const fetchStudents = (className) => {
    // Simulate API call with mock data
    const classStudents = mockStudents[className] || [];
    setStudents(classStudents);

    // Initialize fees for each student
    const initialFees = {};
    const classConstants = classFeeConstants.find(
      (c) => c.class_name === className
    ) || {
      monthly_fee: 0,
      tiffin: 0,
      vehicle_charge: 0,
    };

    classStudents.forEach((student) => {
      const usage = tiffinVehicleUsage[student.studentId] || {};
      initialFees[student.id] = {
        monthlyFee: classConstants.monthly_fee,
        tiffin: usage.uses_tiffin ? classConstants.tiffin : 0,
        vehicleCharge: usage.uses_vehicle ? classConstants.vehicle_charge : 0,
        others: 0,
        otherFeeDescription: "",
      };
    });

    setStudentFees(initialFees);
  };

  const handleSelectClass = (classItem) => {
    setSelectedClass(classItem);
    setSelectedStudent(null);
    fetchStudents(classItem.class_name);
  };

  const handleSelectStudent = (student) => {
    setSelectedStudent(student);
  };

  const handleFeeChange = (studentId, feeType, value) => {
    setStudentFees((prevFees) => ({
      ...prevFees,
      [studentId]: {
        ...prevFees[studentId],
        [feeType]: value,
      },
    }));
  };

  const handleOtherFeeDescriptionChange = (studentId, description) => {
    setStudentFees((prevFees) => ({
      ...prevFees,
      [studentId]: {
        ...prevFees[studentId],
        otherFeeDescription: description,
      },
    }));
  };

  const generateBills = async (studentsToProcess) => {
    setIsGenerating(true);

    try {
      const date = format(new Date(), "yyyy-MM-dd");

      // Generate sequential receipt numbers for each student
      const studentReceipts = {};
      let nextReceiptNumber = receiptCounter;

      studentsToProcess.forEach((student) => {
        const formattedNumber = String(nextReceiptNumber).padStart(5, "0");
        studentReceipts[student.id] = `RM${formattedNumber}`;
        nextReceiptNumber++;
      });

      // Update the receipt counter for next batch
      setReceiptCounter(nextReceiptNumber);

      const generateForm = (student) => `
      <div style="width: calc(33% - 20px); float: left; padding: 20px; margin: 10px; border: 1px dashed black; position: relative; color: black;">
        <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: -1; opacity: 0.1;">
          <img src="${logo}" alt="logo" style="width: 50%; height: 50%; margin-left: 25%; margin-top: 25%;" />
        </div>
        <div style="text-align: center; color: black;">
          <h2 style="color: black;">Hoop</h2>
          <p style="margin-bottom:5px; color: black;">Email: info@bluebugsoft.com | Phone: 01-4037009,9843323731</p>
          <p style="color: black;">Address: Kathmandu, Nepal</p>
          <h3 style="color: black;">Fee Bill</h3>
        </div>
        <div style="width: 50%; float: left; color: black;">
          <p style="color: black;"><strong>Student Name:</strong> ${
            student.firstName
          } ${student.middleName} ${student.lastName}</p>
          <p style="color: black;"><strong>Student ID:</strong> ${
            student.studentId
          }</p>
          <p style="color: black;"><strong>For the month of:</strong> ${
            selectedMonth.nepali
          } (${selectedMonth.english})</p>
        </div>
        <div style="width: 50%; float: left; color: black;">
          <p style="color: black;"><strong>Receipt No:</strong> ${
            studentReceipts[student.id]
          }</p>
          <p style="color: black;"><strong>Date of Issue:</strong> ${date}</p>
          <p style="color: black;"><strong>Class:</strong> ${
            selectedClass.class_name
          }</p>
        </div>
        <table style="clear: both; width: 100%; border-collapse: collapse; color: black;">
          <thead>
            <tr>
              <th style="border: 1px solid black; color: black;">SN</th>
              <th style="border: 1px solid black; color: black;">Fees Description</th>
              <th style="border: 1px solid black; color: black;">Amount Nrs.</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid black; color: black;">1</td>
              <td style="border: 1px solid black; color: black;">Monthly Fee</td>
              <td style="border: 1px solid black; color: black;">Rs.${
                studentFees[student.id]?.monthlyFee || 0
              }</td>
            </tr>
            <tr>
              <td style="border: 1px solid black; color: black;">2</td>
              <td style="border: 1px solid black; color: black;">Tiffin</td>
              <td style="border: 1px solid black; color: black;">Rs.${
                studentFees[student.id]?.tiffin || 0
              }</td>
            </tr>
            <tr>
              <td style="border: 1px solid black; color: black;">3</td>
              <td style="border: 1px solid black; color: black;">Vehicle Charge</td>
              <td style="border: 1px solid black; color: black;">Rs.${
                studentFees[student.id]?.vehicleCharge || 0
              }</td>
            </tr>
            <tr>
              <td style="border: 1px solid black; color: black;">4</td>
              <td style="border: 1px solid black; color: black;">${
                studentFees[student.id]?.otherFeeDescription || "Others"
              }</td>
              <td style="border: 1px solid black; color: black;">Rs.${
                studentFees[student.id]?.others || 0
              }</td>
            </tr>
            <tr>
              <td style="border: 1px solid black; color: black;" colspan="2">Total</td>
              <td style="border: 1px solid black; color: black;">Rs.${(
                parseFloat(studentFees[student.id]?.monthlyFee || 0) +
                parseFloat(studentFees[student.id]?.tiffin || 0) +
                parseFloat(studentFees[student.id]?.vehicleCharge || 0) +
                parseFloat(studentFees[student.id]?.others || 0)
              ).toFixed(2)}</td>
            </tr>
            <tr>
              <td style="border: 1px solid black; color: black;" colspan="2">Dues</td>
              <td style="border: 1px solid black; color: black;">Rs.${parseFloat(
                studentDues[student.studentId] || 0
              ).toFixed(2)}</td>
            </tr>
            <tr>
              <td style="border: 1px solid black; color: black;" colspan="2">Overall Total</td>
              <td style="border: 1px solid black; color: black;">
                Rs.${(
                  parseFloat(studentFees[student.id]?.monthlyFee || 0) +
                  parseFloat(studentFees[student.id]?.tiffin || 0) +
                  parseFloat(studentFees[student.id]?.vehicleCharge || 0) +
                  parseFloat(studentFees[student.id]?.others || 0) +
                  parseFloat(studentDues[student.studentId] || 0)
                ).toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>
        <div style="height: 50px;"></div>
        <div style="margin-top: 10px; border-top: 1px solid black; width:20%; float:right;"></div>
        <div style="margin-top: 20px;">
          <p style="font-size: 12px; text-align: right; margin-bottom: 5px; color: black;">For Hoop</p>
        </div>
      </div>
    `;

      const formsHtml = studentsToProcess
        .map((student) => generateForm(student))
        .join("");

      const container = document.createElement("div");
      container.innerHTML = formsHtml;
      document.body.appendChild(container);

      const pdf = new jsPDF("landscape", "mm", "a4");
      const forms = container.children;
      const pageHeight = pdf.internal.pageSize.getHeight();
      const pageWidth = pdf.internal.pageSize.getWidth();

      let currentRow = 0;
      let currentCol = 0;
      for (let i = 0; i < forms.length; i++) {
        if (i > 0 && i % 6 === 0) {
          pdf.addPage();
          currentRow = 0;
          currentCol = 0;
        }

        const canvas = await html2canvas(forms[i]);
        const imgData = canvas.toDataURL("image/png");
        const xPos = currentCol * (pageWidth / 3);
        const yPos = currentRow * (pageHeight / 2);

        pdf.addImage(imgData, "PNG", xPos, yPos, pageWidth / 3, pageHeight / 2);

        currentCol++;
        if (currentCol > 2) {
          currentCol = 0;
          currentRow++;
        }
      }

      const pdfBlob = pdf.output("blob");
      setPdfBlob(URL.createObjectURL(pdfBlob));
      setShowPdfModal(true);
      document.body.removeChild(container);

      // Simulate saving to database
      setDialog({
        isOpen: true,
        type: "success",
        title: "Success",
        message: "Bills generated and saved successfully!",
        onConfirm: () => setDialog({ isOpen: false }),
      });
    } catch (error) {
      console.error("Error:", error);
      setDialog({
        isOpen: true,
        type: "error",
        title: "Error",
        message: "Error generating bills",
        onConfirm: () => setDialog({ isOpen: false }),
      });
    } finally {
      setIsGenerating(false);
    }
  };

  const handleGenerateBills = async () => {
    if (!selectedMonth) {
      setDialog({
        isOpen: true,
        type: "warning",
        title: "Missing Information",
        message: "Please select a month first",
        onConfirm: () => setDialog({ isOpen: false }),
      });
      return;
    }

    const studentsToProcess = selectedStudent ? [selectedStudent] : students;
    const studentsWithZeroFees = studentsToProcess.filter((student) => {
      const fees = studentFees[student.id] || {};
      const totalFees =
        parseFloat(fees.monthlyFee || 0) +
        parseFloat(fees.tiffin || 0) +
        parseFloat(fees.vehicleCharge || 0) +
        parseFloat(fees.others || 0);
      return totalFees === 0;
    });

    if (studentsWithZeroFees.length > 0) {
      const names = studentsWithZeroFees
        .map((s) => `${s.firstName} ${s.lastName}`)
        .join(", ");
      setDialog({
        isOpen: true,
        type: "confirm",
        title: "Warning",
        message: `The following students have all fees set to 0:\n${names}\n\nDo you want to continue?`,
        onConfirm: () => {
          setDialog({ isOpen: false });
          generateBills(studentsToProcess);
        },
        onCancel: () => setDialog({ isOpen: false }),
      });
      return;
    }

    generateBills(studentsToProcess);
  };

  const handleReset = () => {
    setSelectedClass(null);
    setStudents([]);
    setStudentFees({});
    setSelectedStudent(null);
    setSelectedMonth("");
    setPdfBlob(null);
    setShowPdfModal(false);
    setShowFeeConstants(false);
    setReceiptCounter(1001);
  };

  const handleEditFeeConstants = (classItem) => {
    const existingConstants = classFeeConstants.find(
      (item) => item.class_name === classItem.class_name
    ) || {
      class_name: classItem.class_name,
      monthly_fee: 0,
      tiffin: 0,
      vehicle_charge: 0,
    };

    setEditingFeeConstants(existingConstants);
    setIsEditingConstants(true);
  };

  const handleFeeConstantChange = (field, value) => {
    setEditingFeeConstants((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const saveFeeConstants = () => {
    // Update the mock data
    const updatedConstants = classFeeConstants.map((item) =>
      item.class_name === editingFeeConstants.class_name
        ? editingFeeConstants
        : item
    );

    // If it's a new class, add it
    if (
      !classFeeConstants.some(
        (item) => item.class_name === editingFeeConstants.class_name
      )
    ) {
      updatedConstants.push(editingFeeConstants);
    }

    setClassFeeConstants(updatedConstants);

    setDialog({
      isOpen: true,
      type: "success",
      title: "Success",
      message: "Fee constants saved successfully",
      onConfirm: () => {
        setDialog({ isOpen: false });
        setIsEditingConstants(false);
      },
    });
  };

  const MobileRestriction = () => (
    <div className="mobile-restriction-overlay">
      <div className="mobile-restriction-content">
        <div className="mobile-restriction-icon">💻</div>
        <h2 className="mobile-restriction-title">Desktop Required</h2>
        <p className="mobile-restriction-message">
          This application is optimized for desktop use only. Please access this
          page from a computer or laptop for the best experience.
        </p>
        <p className="mobile-restriction-message">
          <strong>Minimum screen width: 1024px</strong>
        </p>
      </div>
    </div>
  );

  return (
    <>
      {/* Add the style tag */}
      <style>{mobileRestrictStyles}</style>

      {/* Show mobile restriction overlay when on mobile */}
      {isMobile && <MobileRestriction />}

      {/* Your existing component content */}
      <div className="fees-container fix-height box">
        <div className="fees-content">
          <h1 className="main-heading">Fees Management</h1>

          {/* Month Selection Dropdown */}
          <div className="fees-form-section">
            <div className="form-group">
              <label>Select Month: </label>
              <select
                className="form-control"
                value={selectedMonth ? JSON.stringify(selectedMonth) : ""}
                onChange={(e) =>
                  setSelectedMonth(
                    e.target.value ? JSON.parse(e.target.value) : ""
                  )
                }
                required
              >
                <option value="">Select Month</option>
                {nepaliMonths.map((month, index) => (
                  <option key={index} value={JSON.stringify(month)}>
                    {month.nepali} ({month.english})
                  </option>
                ))}
              </select>
            </div>

            {/* Class Selection */}
            <div className="form-group">
              <label>Select Class: </label>
              <select
                className="form-control"
                onChange={(e) => handleSelectClass(JSON.parse(e.target.value))}
                disabled={!selectedMonth}
              >
                <option value="">Select Class</option>
                {classes.map((classItem, index) => (
                  <option key={index} value={JSON.stringify(classItem)}>
                    {classItem.class_name}
                  </option>
                ))}
              </select>
            </div>

            <button
              className="btn-link"
              style={{
                marginTop: "15px",
                display: "block",
                color: "#4a6da7",
                textDecoration: "underline",
                border: "none",
                background: "none",
                cursor: "pointer",
              }}
              onClick={() => setShowFeeConstants(!showFeeConstants)}
            >
              {showFeeConstants ? "Hide" : "Show"} Fee Constants
            </button>

            {showFeeConstants && (
              <div
                className="fee-constants-section"
                style={{
                  marginTop: "15px",
                  padding: "15px",
                  border: "1px solid #ddd",
                  borderRadius: "5px",
                  backgroundColor: "#f9f9f9",
                }}
              >
                <h3 style={{ marginBottom: "15px", color: "#333" }}>
                  Class Fee Constants
                </h3>
                <div className="fee-constants-table">
                  <table
                    className="table"
                    style={{ width: "100%", borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr
                        style={{ backgroundColor: "#4a6da7", color: "white" }}
                      >
                        <th
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            border: "1px solid #ddd",
                          }}
                        >
                          Class
                        </th>
                        <th
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            border: "1px solid #ddd",
                          }}
                        >
                          Monthly Fee
                        </th>
                        <th
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            border: "1px solid #ddd",
                          }}
                        >
                          Tiffin
                        </th>
                        <th
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            border: "1px solid #ddd",
                          }}
                        >
                          Vehicle Charge
                        </th>
                        <th
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            border: "1px solid #ddd",
                          }}
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {classes.map((classItem) => {
                        const constants = classFeeConstants.find(
                          (item) => item.class_name === classItem.class_name
                        ) || {
                          monthly_fee: 0,
                          tiffin: 0,
                          vehicle_charge: 0,
                        };

                        return (
                          <tr
                            key={classItem.id}
                            style={{ borderBottom: "1px solid #ddd" }}
                          >
                            <td
                              style={{
                                padding: "8px",
                                border: "1px solid #ddd",
                              }}
                            >
                              {classItem.class_name}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                border: "1px solid #ddd",
                              }}
                            >
                              {constants.monthly_fee}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                border: "1px solid #ddd",
                              }}
                            >
                              {constants.tiffin}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                border: "1px solid #ddd",
                              }}
                            >
                              {constants.vehicle_charge}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                border: "1px solid #ddd",
                              }}
                            >
                              <button
                                className="action-button"
                                style={{
                                  background: "#4a6da7",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "4px",
                                  padding: "5px 10px",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  handleEditFeeConstants(classItem)
                                }
                              >
                                <FaEdit />
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {isEditingConstants && (
                  <div
                    className="edit-constants-form"
                    style={{
                      marginTop: "20px",
                      padding: "15px",
                      border: "1px solid #ddd",
                      borderRadius: "5px",
                      backgroundColor: "white",
                    }}
                  >
                    <h4 style={{ marginBottom: "15px", color: "#333" }}>
                      Edit Fee Constants for {editingFeeConstants.class_name}
                    </h4>
                    <div
                      className="form-row"
                      style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}
                    >
                      <div className="form-group">
                        <label>Monthly Fee:</label>
                        <input
                          type="number"
                          className="form-control"
                          value={editingFeeConstants.monthly_fee}
                          onChange={(e) =>
                            handleFeeConstantChange(
                              "monthly_fee",
                              Number(e.target.value)
                            )
                          }
                          min="0"
                        />
                      </div>
                      <div className="form-group">
                        <label>Tiffin:</label>
                        <input
                          type="number"
                          className="form-control"
                          value={editingFeeConstants.tiffin}
                          onChange={(e) =>
                            handleFeeConstantChange(
                              "tiffin",
                              Number(e.target.value)
                            )
                          }
                          min="0"
                        />
                      </div>
                      <div className="form-group">
                        <label>Vehicle Charge:</label>
                        <input
                          type="number"
                          className="form-control"
                          value={editingFeeConstants.vehicle_charge}
                          onChange={(e) =>
                            handleFeeConstantChange(
                              "vehicle_charge",
                              Number(e.target.value)
                            )
                          }
                          min="0"
                        />
                      </div>
                    </div>
                    <div
                      className="form-actions"
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      <button
                        className="save-btn"
                        onClick={saveFeeConstants}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          background: "#4CAF50",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          padding: "8px 15px",
                          cursor: "pointer",
                        }}
                      >
                        <FaSave /> Save
                      </button>
                      <button
                        className="cancel-btn"
                        onClick={() => setIsEditingConstants(false)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          background: "#f44336",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          padding: "8px 15px",
                          cursor: "pointer",
                        }}
                      >
                        <IoMdClose /> Cancel
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          {selectedClass && selectedMonth && (
            <div className="fees-details-section">
              <button className="reset-btn" onClick={handleReset}>
                <div>
                  <RiResetLeftLine />
                </div>
                Reset
              </button>
              <div className="form-group" style={{ marginBottom: "15px" }}>
                <label>Select Student (Optional): </label>
                <select
                  className="form-control"
                  onChange={(e) =>
                    handleSelectStudent(
                      e.target.value ? JSON.parse(e.target.value) : null
                    )
                  }
                >
                  <option value="">All Students</option>
                  {students.map((student) => (
                    <option key={student.id} value={JSON.stringify(student)}>
                      {student.firstName} {student.lastName}
                    </option>
                  ))}
                </select>
              </div>
              <h2 className="" style={{ marginTop: "10px" }}>
                {selectedClass.class_name}
              </h2>
              <div className="fee-form-group">
                {(selectedStudent ? [selectedStudent] : students).map(
                  (student) => (
                    <div className="fee-form" key={student.id}>
                      <h3 className="sub-heading">
                        {student.firstName} {student.middleName}{" "}
                        {student.lastName}
                      </h3>
                      <div className="form-row">
                        <div className="form-group">
                          <label>Monthly Fee: </label>
                          <input
                            type="number"
                            className="form-control"
                            value={studentFees[student.id]?.monthlyFee || ""}
                            onChange={(e) => {
                              const value = Math.max(0, Number(e.target.value));
                              handleFeeChange(student.id, "monthlyFee", value);
                            }}
                            min="0"
                            required
                          />
                        </div>

                        <div className="form-group">
                          <label>Tiffin: </label>
                          <input
                            type="number"
                            className="form-control"
                            value={studentFees[student.id]?.tiffin || ""}
                            onChange={(e) => {
                              const value = Math.max(0, Number(e.target.value));
                              handleFeeChange(student.id, "tiffin", value);
                            }}
                            min="0"
                          />
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="form-group">
                          <label>Vehicle Charge: </label>
                          <input
                            type="number"
                            className="form-control"
                            value={studentFees[student.id]?.vehicleCharge || ""}
                            onChange={(e) => {
                              const value = Math.max(0, Number(e.target.value));
                              handleFeeChange(
                                student.id,
                                "vehicleCharge",
                                value
                              );
                            }}
                            min="0"
                          />
                        </div>
                        <div className="form-group">
                          <label>Others (Specify): </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Additional fees title"
                            value={
                              studentFees[student.id]?.otherFeeDescription || ""
                            }
                            onChange={(e) =>
                              handleOtherFeeDescriptionChange(
                                student.id,
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="form-group">
                          <label>Others Amount: </label>
                          <input
                            type="number"
                            className="form-control"
                            value={studentFees[student.id]?.others || ""}
                            onChange={(e) => {
                              const value = Math.max(0, Number(e.target.value));
                              handleFeeChange(student.id, "others", value);
                            }}
                            min="0"
                          />
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="form-group">
                          <label>Previous Dues: </label>
                        </div>
                        <div className="form-group">
                          <input
                            type="number"
                            className="form-control"
                            value={studentDues[student.studentId] || 0}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
              <button
                className="generate-bill-btn"
                onClick={handleGenerateBills}
              >
                Generate and Save Bills
              </button>
            </div>
          )}
        </div>

        {/* Loading Modal */}
        {isGenerating && (
          <div className="loading-modal-overlay">
            <div className="loading-modal">
              <div className="loading-spinner"></div>
              <p>Generating Bills...</p>
            </div>
          </div>
        )}

        {/* PDF Modal */}
        {showPdfModal && (
          <div
            className="pdf-modal-overlay"
            onClick={() => setShowPdfModal(false)}
          >
            <div
              className="pdf-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-header">
                <h3>Fee Bill Preview</h3>
                <button
                  className="close-btn"
                  onClick={() => setShowPdfModal(false)}
                >
                  <IoMdClose />
                </button>
              </div>
              <div className="pdf-container">
                <embed
                  src={pdfBlob}
                  type="application/pdf"
                  width="100%"
                  height="600px"
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <Dialog
        isOpen={dialog.isOpen}
        type={dialog.type}
        title={dialog.title}
        message={dialog.message}
        onConfirm={dialog.onConfirm}
        onCancel={dialog.onCancel}
      />
    </>
  );
};

export default Fees;
